import React from "react";
import { useDispatch } from "react-redux";
import { hideModal } from "../../../actions/actionCreators";
import MaterialModal from "../MaterialModal";
import withModal from "../withModal";

interface IAdvertiserDeleteModal {
    isOpen: boolean;
    modalProps: {
        displayName: string;
    };
}

const SAAAdvertiserDeleteModal: React.FC<IAdvertiserDeleteModal> = ({ isOpen, modalProps }: IAdvertiserDeleteModal) => {
    const dispatch = useDispatch();

    const hide = () => dispatch(hideModal("DELETE_SAA_ADVERTISER_DENIED"));

    return (
        <MaterialModal
            title="SAA Advertiser Assigned"
            isOpen={isOpen}
            cancelButtonText="Close"
            onClose={() => hide()}
            id="flow-delete"
            maxWidth="lg"
            showPrimaryButton={false}
        >
            <div>
                <span style={{ fontSize: "16px" }}>
                    Cannot delete SAA Advertiser <strong>{modalProps.displayName}</strong> because it is assigned to SAA
                    Templates
                </span>
            </div>
        </MaterialModal>
    );
};

export default withModal(SAAAdvertiserDeleteModal, "DELETE_SAA_ADVERTISER_DENIED");
